import { IUserListSearchFilters } from "../interfaces/user-list-search-filters";

export const removeNullUndefined = (obj: IUserListSearchFilters) =>
  Object.entries(obj)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .filter(([_, v]) => {
      return v || v === 0;
    })
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
